import { useEffect, useState } from "react";
import { Box, Button, Modal, Grid, Typography, TextField, FormControlLabel, Checkbox, Select, FormControl, InputLabel, MenuItem } from "@mui/material";
import dayjs from "dayjs";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { updateFutureUserPremium } from "services/mobile-app.service";

dayjs.extend(utc);
dayjs.extend(timezone);

// function sleep(ms: number) {
//   return new Promise((resolve) => {
//     setTimeout(resolve, ms);
//   });
// }

type Props = {
  close: () => void;
  visible: boolean;
  toEdit: any;
};

function EditUserModal({ close, visible, toEdit }: Props) {
  const [id, setId] = useState(false);
  const [used, setUsed] = useState(false);
  const [time, setTime] = useState("");
  const [email, setEmail] = useState("");
  const [profesionalUser, setProfesionalUser] = useState(false);
  const [premiumUser, setPremiumUser] = useState("plus");
  const [minorModal, setMinorModal] = useState(false);
  async function sendNewPremium() {
    await updateFutureUserPremium({ 
      id:id,
      email: email, 
      time: time, 
      account_type:profesionalUser, 
      type: premiumUser=='premium'?1:0});
  }
  useEffect(()=>{
    setId(toEdit.id)
    setTime(toEdit.time)
    setEmail(toEdit.email)
    setUsed(toEdit.used)
    setProfesionalUser(toEdit.account_type)
    setPremiumUser(toEdit.premium_type==0?'plus':'premium')
  },[toEdit])
  return (
    <Modal open={visible}>
      <form>
        <Box sx={modalStyle}>
          <Grid container>
            <Grid
              container
              spacing={1 / 2}
              style={{ display: "flex", flexDirection: "row" }}
              p={1}
            >
              <Grid item xs={6}>
                <TextField
                  label="Correo"
                  value={email}
                  disabled={used}
                  onChange={(el) => setEmail(el.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Tiempo (meses)"
                  disabled={used}
                  value={time}
                  onChange={(el) => setTime(el.target.value)}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} sx={{alignContent:'center'}}>
                <FormControl fullWidth>
                  <InputLabel id="premiumUser">Tipo de cuenta</InputLabel>
                  <Select
                    labelId="premiumUser"
                    id="premiumUser-select"
                    value={premiumUser}
                    label="Age"
                    onChange={(val)=>setPremiumUser(val.target.value)}
                  >
                    <MenuItem value={'premium'}>Premium</MenuItem>
                    <MenuItem value={'plus'}>Plus</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sx={{alignContent:'center'}}>
                <FormControlLabel
                    control={
                    <Checkbox checked={profesionalUser} onClick={() => setProfesionalUser(!profesionalUser)} />
                    }
                    label="Es profesional?"
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={6} p={1}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  sendNewPremium();
                  close();
                }}
              >
                Editar
              </Button>
            </Grid>
            <Grid item xs={6} p={1}>
              <Button
                variant="contained"
                fullWidth
                onClick={() => {
                  close();
                }}
              >
                Cerrar
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Modal open={minorModal}>
          <Box sx={minorStyle}>
            <Grid container flexDirection={"row"}>
              <Grid container p={1}>
                <Grid item>
                  <Typography variant="h6" color={"black"}>
                    Error al guardar usuario.
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <Button
                    variant="contained"
                    onClick={() => setMinorModal(false)}
                  >
                    Cerrar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </form>
    </Modal>
  );
}

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  minWidth: "70%",
};

const minorStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  bgcolor: "white",
  p: 4,
  display: "flex",
  flexDirection: "column",
  transform: "translate(-50%, -50%)",
  // minWidth:'70%'
};

export default EditUserModal;
